<template>
  <div>
    <el-form-item>
      <el-checkbox
        v-model="localConfig.enable"
        @change="updateConfig"
      >
        启用系列跟踪模板（针对同一个账户多个人使用）
      </el-checkbox>
    </el-form-item>

    <el-form-item
      v-if="localConfig.enable"
      :prop="'utmSourceConfig'"
    >
      <el-radio-group
        v-model="localConfig.utmSourceConfig"
        @change="updateChannels"
        class="flex flex-wrap gap-4"
      >
        <el-radio
          v-for="option in channelOptions"
          :key="option.value"
          :label="option.value"
        >
          {{ option.label }}
        </el-radio>
      </el-radio-group>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'CampaignTraceConfig',
  props: {
    value: {
      type: Object,
      default: () => ({
        enable: false,
        utmSourceConfig: null,
        tracingTemplateUrl: '',
      }),
    },
  },
  data() {
    return {
      localConfig: { ...this.value },
      channelOptions: [
        { value: 'GMALL3', label: '商城3.0' },
        { value: 'SHOP_PLUS', label: '商城Plus' },
        { value: 'SHOPLINE', label: 'shopline' },
        { value: 'SHOPIFY', label: 'shopify' },
      ],
    };
  },

  watch: {
    value: {
      handler() {
        this.localConfig = { ...this.value };
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    updateConfig() {
      if (!this.localConfig.enable) {
        this.localConfig.utmSourceConfig = null;
      }

      this.$emit('input', { ...this.value, ...this.localConfig });
      this.$emit('changeCampaignTraceConfig', { ...this.value, ...this.localConfig });
    },
    updateChannels() {
      this.$emit('input', { ...this.value, ...this.localConfig });
      this.$emit('changeCampaignTraceConfig', { ...this.value, ...this.localConfig });
    },
  },
};
</script>

<style scoped></style>
